import { useState,useEffect } from "react";
import { NotificationContext } from "./NotificationContext";

import { isApiConfigured } from '../api/axiosClient';

import { userApi } from '../api/userApi';
import { useAuth } from '../auth/AuthContext';


export const NotificationProvider = ({ children }) => {
    const { user } = useAuth();
    const [allNotificationData, setAllNotificationData] = useState([]);
    



    const refreshNotifications = async () => {        
        
        await getUserNotifications();
    };
    const getUserNotifications = async () => {
        
        
        if (isApiConfigured()) {
            setAllNotificationData([]);

            try {
                const response = await userApi.userNotifications({
                    userId: user?.userId
                });


                if (Array.isArray(response.data) && response.data.length > 0) {
                    // console.log("User have notifications");
                    setAllNotificationData(response.data);

                }
                else {
                    setAllNotificationData([]);                    
                }

                
            } catch (err)
            {
                
                console.log("-------------------------------------------");
                console.log("Error to get user notifications : " + err);
                console.log("-------------------------------------------");

            } finally {
                

            }
        }
    };

    useEffect(() => {
        if (user?.userId) {
            getUserNotifications(user.userId);
        } else {
            setAllNotificationData([]);
        }
    }, [user?.userId]);

    return (
        <NotificationContext.Provider
            value={{
                allNotificationData,
                setAllNotificationData,
                refreshNotifications
                
            }}
        >
            {children}
        </NotificationContext.Provider>
    );
};